import React, {
    useCallback,
    useEffect,
    useState,
    useRef,
    useContext,
} from "react";
import { getAccountSummaryByCrypto } from "../api/apiCalls";
import GlobalContext from "../contexts/globalcontext";
import {
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Modal,
    Avatar,
    Grid,
} from "@mui/material";
import { Delete, AddBox } from "@mui/icons-material";
import AccountBalanceModalAdd from "./AccountBalanceModalAdd";

const AccountsBalance = () => {
    const { setSbOpen, setSbMsg, setSbSeverity } = useContext(GlobalContext);
    const arrSCrypto = [
        { name: "cro", dec: 1 },
        { name: "btc", dec: 5 },
        { name: "eth", dec: 4 },
    ];
    const firstLoad = useRef(true);
    const [arrCrypto, setArrCrypto] = useState(
        JSON.parse(localStorage.getItem("balanceList")) || arrSCrypto
    );
    const [balance, setBalance] = useState([]);

    const [openM, setOpenM] = React.useState(false);
    const handleOpenM = () => setOpenM(true);
    const handleCloseM = () => setOpenM(false);

    const handleAddCrypto = async (name, dec) => {
        console.log(name, dec);
        const checkArray = arrCrypto.find(
            (item) => item.name === name.toLowerCase()
        );
        if (checkArray) {
            setSbOpen(true);
            setSbSeverity("info");
            setSbMsg("Crypto already in List");
        } else {
            //Check if CDC got this crypto
            let res = await getAccountSummaryByCrypto(name);
            if (res.balance) {
                console.log(res);
                setArrCrypto([
                    ...arrCrypto,
                    { name: name.toLowerCase(), dec: dec },
                ]);
                setSbSeverity("success");
                setSbMsg(`${name} Added to Balance List`);
                setSbOpen(true);
            } else {
                setSbSeverity("error");
                setSbMsg(`${name} Not Found or Zero balance`);
                setSbOpen(true);
            }
        }
    };

    const handleDelete = (name) => {
        setArrCrypto(
            arrCrypto.filter((item) => item.name !== name.toLowerCase())
        );
        setSbSeverity("success");
        setSbMsg(`${name.toUpperCase()} removed from List`);
        setSbOpen(true);
    };

    const getAllBalanceByArray = useCallback(async () => {
        let newarr = [];
        // console.log(arrCrypto.length, newarr);
        for (let i = 0; i < arrCrypto.length; i++) {
            let res = await getAccountSummaryByCrypto(arrCrypto[i].name);
            if (res.currency) {
                res.dec = arrCrypto[i].dec;
                newarr.push(res);
            }
        }
        // console.log(arrCrypto.length, newarr);
        setBalance(newarr);
    }, [arrCrypto]);

    useEffect(() => {
        // console.log("accounts balance-useEffect-loadBalance");
        getAllBalanceByArray();
        if (firstLoad.current) {
            firstLoad.current = false;
        } else {
        }
    }, [getAllBalanceByArray, arrCrypto]);

    useEffect(() => {
        localStorage.setItem("balanceList", JSON.stringify(arrCrypto));
    }, [arrCrypto]);

    return (
        <>
            <Typography variant="h6">
                Accounts Balance
                <Button onClick={handleOpenM} sx={{ margin: 0 }}>
                    <AddBox />
                </Button>
            </Typography>
            <TableContainer component={Paper} sx={{ width: 600 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: "100px" }}>
                                Crypto
                            </TableCell>
                            <TableCell align="right">Balance</TableCell>
                            <TableCell align="right">Available</TableCell>
                            <TableCell align="right">Order / Stake</TableCell>
                            <TableCell align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {balance.map((item) => {
                            const {
                                balance,
                                available,
                                order,
                                currency,
                                stake,
                                dec,
                            } = item;
                            return (
                                <TableRow key={currency}>
                                    <TableCell>
                                        <Grid container>
                                            <Grid item xs={6}>
                                                <Avatar
                                                    src={`cryptoimg/${currency.toLowerCase()}.jpg`}
                                                    sx={{
                                                        width: 24,
                                                        height: 24,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={6}
                                                sx={{ marginTop: "3px" }}
                                            >
                                                {currency}
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell align="right">
                                        {balance.toFixed(dec)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {available.toFixed(dec)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {order.toFixed(dec)}
                                        <br />
                                        {stake !== 0.0
                                            ? stake.toFixed(dec)
                                            : ""}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        //     sx={{ justifyContent: "space-evenly" }}
                                    >
                                        <Button
                                            onClick={() => {
                                                handleDelete(currency);
                                            }}
                                        >
                                            <Delete />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Modal
                open={openM}
                onClose={handleCloseM}
                aria-labelledby="modal-Add Cryto"
            >
                <AccountBalanceModalAdd handleAddCrypto={handleAddCrypto} />
            </Modal>
        </>
    );
};

export default AccountsBalance;
